/* unplugin-vue-components disabled */import { render } from "./xLayoutFooter.vue?vue&type=template&id=587af8be"
import script from "./xLayoutFooter.vue?vue&type=script&lang=jsx"
export * from "./xLayoutFooter.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__